// export const LOADING = 'LOADING';

const AuthenticateActionTypes = {};

AuthenticateActionTypes.AUTHENTICATE = 'AUTHENTICATE';

export default AuthenticateActionTypes;
